module.exports = __webpack_public_path__ + "img/logo-icon-app.6d04bc6d.png";